import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

// ─── Company stats (SuperAdmin only) ──────────────────────────────────────────

export interface CompanyOverview {
  totalLeads: number;
  leadsToday: number;
  dealsActive: number;
  dealsValue: number;
  dealsWon: number;
  contacts: number;
  totalStaff: number;
  onLeave: number;
  pendingLeaves: number;
  activeProjects: number;
  openTasks: number;
  doneTasks: number;
}

export interface DepartmentRow {
  department: string;
  total: number;
  active_count: number;
}

export interface CompanyStatsResponse {
  overview: CompanyOverview;
  byDepartment: DepartmentRow[];
}

export function useCompanyStats(enabled: boolean) {
  return useQuery({
    queryKey: ['company-stats'],
    queryFn: async () => {
      const { data } = await api.get<CompanyStatsResponse>('/api/company/stats');
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}

// ─── Work hours (Admin) ───────────────────────────────────────────────────────

export interface WorkHoursRow {
  id: string;
  user_id: string;
  display_name: string;
  department: string;
  check_in?: string;
  check_out?: string;
  break_sec: number;
  gross_sec: number;
  net_sec: number;
}

export interface WorkHoursResponse {
  date: string;
  rows: WorkHoursRow[];
}

export function useWorkHours(date: string, enabled: boolean) {
  return useQuery({
    queryKey: ['work-hours', date],
    queryFn: async () => {
      const { data } = await api.get<WorkHoursResponse>(`/api/admin/work-hours?date=${date}`);
      return data;
    },
    enabled,
    placeholderData: keepPreviousData,
  });
}
